import useSWR from 'swr';
import { useContext } from 'react';
import { useAuthToken } from '@/contexts/auth/useAuthToken';
import { ScoringContext } from '@/contexts/scoring/context';
import { NotificationsConfiguration } from '../types';
import {
  fetchFromMTService,
  SERVICE_ENDPOINT,
} from '../fetcher/monitoringToolService';
import { ApiError } from '../ApiError';
import { HTTP_STATUS_CODE } from '../constants';

export interface UseNotificationsConfigurationParams {
  token: string | undefined;
  fixtureId?: string;
}
export const useNotificationsConfiguration = () => {
  const token = useAuthToken();
  const {
    state: { fixtureSummary },
  } = useContext(ScoringContext);
  const {
    data: notificationsConfiguration,
    error,
    mutate,
  } = useSWR<NotificationsConfiguration | null, ApiError>(
    token && fixtureSummary?.collectionId
      ? {
          token,
          endpoint: SERVICE_ENDPOINT.Collections(fixtureSummary?.collectionId)
            .notificationsConfiguration.GET,
        }
      : null,
    fetchFromMTService,
    {
      onErrorRetry: (e, _, config, revalidate, { retryCount }) => {
        if (e.status === HTTP_STATUS_CODE.NOT_FOUND) return;
        if (e.status === HTTP_STATUS_CODE.UNAUTHORIZED) return;
        setTimeout(() => revalidate({ retryCount }), config.errorRetryInterval);
      },
      revalidateOnFocus: false,
    },
  );

  return {
    notificationsConfiguration,
    error,
    isLoading: !notificationsConfiguration && !error,
    mutate,
  };
};
